/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import 'firebase/auth'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default {
  // isUserLoggedIn: () => {
  //     let isAuthenticated = false

  //     // get firebase current user
  //     const firebaseCurrentUser = firebase.auth().currentUser

  //     if (auth.isAuthenticated() || firebaseCurrentUser) isAuthenticated = true
  //     else isAuthenticated = false

  //     return (localStorage.getItem('userInfo') && isAuthenticated)
  // },
  status: '',
  token: localStorage.getItem('accessToken') || '',
  user: {},
  userInfo: {},
  info: {},
  checkOtp: {},
  config: {},
  idDomain: {},
  mercure: {},
  userSigninInfo: {},
  userInfoError: {},
}
